/**
 * TabbedDashLayout addresses tabs positionally through `?tab=N`, so any link that targets a
 * specific facility tab has to move with FacilityDetails' tab array. Keep these in step with it.
 */
export const FacilityTab = {
    Details: 0,
    RecentTargets: 1,
    ParkingView: 2,
    Layout: 3,
    Devices: 4,
    Reports: 5,
    Integrations: 6,
    Events: 7,
} as const;
